module.exports = __webpack_public_path__ + "img/viagem-argentina.2dd8162b.jpeg";